import { Component, OnInit } from '@angular/core';
import { FillerService } from '../../common/Service_tnFiller';
import { Router, NavigationExtras, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'tn-search-code',
  templateUrl: '../../themes/default/html/tnsearchcode.component.html',
  styleUrls: ['../../themes/default/css/tnsearchcode.component.scss']
})
export class TnsearchcodeComponent implements OnInit {

  isCollapsedSearch = false;
  searchCode: any;

  public Advertisement: any = {
    ExtraData: '',
    Geo: {},
    Links: []
  };

  constructor(private filler: FillerService, private router: Router) { }

  ngOnInit() {
  }

  ToggleCollapseSearch() {
    this.isCollapsedSearch = !this.isCollapsedSearch;
  }

  SearchCode() {
    console.log('Ricerca per codice: ' + this.searchCode);

    var payload = {};
    payload = JSON.stringify({code: this.searchCode, uiCulture: "it"});

    new Promise((resolve, reject) => {
      this.filler.Get_Advertisement(payload).subscribe(
          data => {
            this.Advertisement = Object.assign([], data);            
            resolve(true);
          }, err => { 
                      console.log('Risultato della ricerca (err): ' + err);
                    }
        );
    }).then(
      e => {
        
        console.log('Risultato della ricerca (e): ' + e);
        this.router.navigate(['/detail',this.searchCode]);

      }
    );

  }
}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/components/tnsearchcode/tnsearchcode.component.ts